import React from 'react';
import { createRoot } from 'react-dom/client';
import { Notifications } from '@bynder/design-system';

import { AbilityContext } from './abilities/Can';
import ability from './abilities/ability';
import { Main } from './connectors/Main/Main';
import MessageBox from './components/MessageBox';
import { rootHeader as rootHeaderSelector, rootMessageBox as rootMessageSelector } from './roots';

const containerHeader = document.querySelector(rootHeaderSelector);
const containerMessageBox = document.querySelector(rootMessageSelector);

if (containerHeader) {
	const rootHeader = createRoot(containerHeader);
	rootHeader.render(
		<>
			<AbilityContext.Provider value={ability}>
				<Main />
			</AbilityContext.Provider>
			<Notifications />
		</>,
	);
}

if (containerMessageBox) {
	const rootMessageBox = createRoot(containerMessageBox);
	rootMessageBox.render(<MessageBox />);
}
